import { Routes, Route, Navigate } from 'react-router-dom'
import { useApp } from './context/AppContext'
import Login from './pages/Login'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Cadastros from './pages/Cadastros'
import Clientes from './pages/Clientes'
import Obras from './pages/Obras'
import Fornecedores from './pages/Fornecedores'
import Categorias from './pages/Categorias'
import Colaboradores from './pages/Colaboradores'
import Orcamento from './pages/Orcamento'
import Requisicoes from './pages/Requisicoes'
import Cotacoes from './pages/Cotacoes'
import OrdensCompra from './pages/OrdensCompra'
import ContasPagar from './pages/ContasPagar'
import Pagamentos from './pages/Pagamentos'
import Aprovacoes from './pages/Aprovacoes'
import Auditoria from './pages/Auditoria'
import Usuarios from './pages/Usuarios'
import EmConstrucao from './pages/EmConstrucao'
import { canAccessPath, getDefaultPath } from './lib/accessControl'

function ProtectedPage({ path, children }: { path: string; children: React.ReactElement }) {
  const { currentUser } = useApp()
  const defaultPath = getDefaultPath(currentUser?.perfil)

  if (!canAccessPath(currentUser?.perfil, path)) {
    return <Navigate to={defaultPath} replace />
  }

  return children
}

function App() {
  const { currentUser, authSessionRestoring } = useApp()

  if (!currentUser && authSessionRestoring) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#0f1011', color: '#8a8f98', fontSize: 13 }}>
        Restaurando sessao...
      </div>
    )
  }

  if (!currentUser) return <Login />
  const defaultPath = getDefaultPath(currentUser.perfil)

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to={defaultPath} replace />} />
        <Route path="/dashboard" element={<ProtectedPage path="/dashboard"><Dashboard /></ProtectedPage>} />
        <Route path="/cadastros" element={<ProtectedPage path="/cadastros"><Cadastros /></ProtectedPage>} />
        <Route path="/clientes" element={<ProtectedPage path="/clientes"><Clientes /></ProtectedPage>} />
        <Route path="/obras" element={<ProtectedPage path="/obras"><Obras /></ProtectedPage>} />
        <Route path="/fornecedores" element={<ProtectedPage path="/fornecedores"><Fornecedores /></ProtectedPage>} />
        <Route path="/categorias" element={<ProtectedPage path="/categorias"><Categorias /></ProtectedPage>} />
        <Route path="/categorias-orcamentarias" element={<ProtectedPage path="/categorias-orcamentarias"><Categorias /></ProtectedPage>} />
        <Route path="/colaboradores" element={<ProtectedPage path="/colaboradores"><Colaboradores /></ProtectedPage>} />
        <Route path="/orcamento" element={<ProtectedPage path="/orcamento"><Orcamento /></ProtectedPage>} />
        <Route path="/requisicoes" element={<ProtectedPage path="/requisicoes"><Requisicoes /></ProtectedPage>} />
        <Route path="/cotacoes" element={<ProtectedPage path="/cotacoes"><Cotacoes /></ProtectedPage>} />
        <Route path="/ordens-compra" element={<ProtectedPage path="/ordens-compra"><OrdensCompra /></ProtectedPage>} />
        <Route path="/contas-pagar" element={<ProtectedPage path="/contas-pagar"><ContasPagar /></ProtectedPage>} />
        <Route path="/pagamentos" element={<ProtectedPage path="/pagamentos"><Pagamentos /></ProtectedPage>} />
        <Route path="/aprovacoes" element={<ProtectedPage path="/aprovacoes"><Aprovacoes /></ProtectedPage>} />
        <Route path="/auditoria" element={<ProtectedPage path="/auditoria"><Auditoria /></ProtectedPage>} />
        <Route path="/usuarios" element={<ProtectedPage path="/usuarios"><Usuarios /></ProtectedPage>} />
        <Route path="/recebimentos" element={<ProtectedPage path="/recebimentos"><EmConstrucao /></ProtectedPage>} />
        <Route path="/contas-receber" element={<ProtectedPage path="/contas-receber"><EmConstrucao /></ProtectedPage>} />
        <Route path="/fluxo-caixa" element={<ProtectedPage path="/fluxo-caixa"><EmConstrucao /></ProtectedPage>} />
        <Route path="/conciliacao" element={<ProtectedPage path="/conciliacao"><EmConstrucao /></ProtectedPage>} />
        <Route path="/parametros" element={<ProtectedPage path="/parametros"><EmConstrucao /></ProtectedPage>} />
        <Route path="/regras-workflow" element={<ProtectedPage path="/regras-workflow"><EmConstrucao /></ProtectedPage>} />
        <Route path="*" element={<Navigate to={defaultPath} replace />} />
      </Routes>
    </Layout>
  )
}

export default App
